import { inject, Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import { difference } from 'lodash';
import { Observable, take } from 'rxjs';
import { selectPermissionGroups } from '../../admin/store/general/admin.selectors';
import { UserProfile } from '../utility/auth.models';
import { PermissionsService } from './permissions.service';

@Pipe({ name: 'hasPermissions' })
export class HasPermissionsPipe implements PipeTransform {
  constructor(private readonly permissions: PermissionsService) {}

  transform(permissions: string | string[]): Observable<boolean> {
    return this.permissions.hasPermissions(permissions);
  }
}

@Pipe({ name: 'hasSomePermission' })
export class HasSomePermissionPipe implements PipeTransform {
  constructor(private readonly permissions: PermissionsService) {}

  transform(permissions: string | string[]): Observable<boolean> {
    return this.permissions.hasPermissions(permissions);
  }
}

@Pipe({ name: 'hasRole' })
export class HasRolePipe implements PipeTransform {
  private readonly store = inject(Store);

  transform(user: UserProfile, roles: string | string[]) {
    let result = false;
    this.store
      .select(selectPermissionGroups)
      .pipe(take(1))
      .subscribe(rl => {
        const roleIds = typeof roles === 'string'
          ? [(rl.value ?? []).find(r => r.name.toLowerCase() === roles.toLowerCase())?.id ?? -1]
          : roles.map(r => (rl.value ?? []).find(_r => _r.name.toLowerCase() === r.toLowerCase())?.id ?? -1)
        result = difference(roleIds, user.groups).length === 0;
      });
    return result;
  }
}

@Pipe({ name: 'isOwner' })
export class IsOwnerPipe implements PipeTransform {
  private readonly store = inject(Store);

  transform(user: UserProfile) {
    let adminRoleId = -1;
    this.store
      .select(selectPermissionGroups)
      .pipe(take(1))
      .subscribe(
        r => (adminRoleId = r.value?.find(v => v.name.toLowerCase() === 'owner')?.id ?? -1)
      );
    return user.groups.includes(adminRoleId);
  }
}
